<template>
    <!--

	Copyright (c) 2020 - JESSE COUCH - https://codepen.io/designcouch/pen/Atyop

	Permission is hereby granted, free of charge, to any person 
	obtaining a copy of this software and associated documentation 
	files (the "Software"), to deal in the Software without restriction,
	including without limitation the rights to use, copy, modify, 
	merge, publish, distribute, sublicense, and/or sell copies of 
	the Software, and to permit persons to whom the Software is 
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall 
	be included in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, 
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES 
	OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND 
	NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT 
	HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, 
	WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER 
	DEALINGS IN THE SOFTWARE.

	-->
    <div class="nav-icon3" :class="{ open: isOpen }">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: { isOpen: Boolean },
});
</script>

<style lang="scss">
.nav-icon3 {
    width: 40px;
    height: 30px;
    position: relative;
    transform: rotate(0deg);
    transition: 0.5s ease-in-out;
    cursor: pointer;

    z-index: 1;

    span {
        display: block;
        position: absolute;
        height: 4px;
        width: 100%;
        background: #bdbdbd;
        border-radius: 2px;
        opacity: 1;
        left: 0;
        transform: rotate(0deg);
        transition: 0.25s ease-in-out;
    }
}

.nav-icon3 span:nth-child(1) {
    top: 0px;
}

.nav-icon3 span:nth-child(2),
.nav-icon3 span:nth-child(3) {
    top: 12px;
}

.nav-icon3 span:nth-child(4) {
    top: 24px;
}

.nav-icon3.open span:nth-child(1) {
    top: 12px;
    width: 0%;
    left: 50%;
}

.nav-icon3.open span:nth-child(2) {
    transform: rotate(45deg);
}

.nav-icon3.open span:nth-child(3) {
    transform: rotate(-45deg);
}

.nav-icon3.open span:nth-child(4) {
    top: 12px;
    width: 0%;
    left: 50%;
}
</style>
